import { TChatThread } from "@/store/thread/types";

/**
 * Checks whether an array of chat threads contains at least one thread with a non-empty title.
 *
 * @param threads - The array of chat threads to validate.
 * @returns True if the array exists, has at least one element, and contains at least one thread with a non-empty title;
 * otherwise false.
 */

export const hasValidThreads = (threads: TChatThread[]) => {
  return threads && threads.length > 0 && threads.some((thread) => thread.title && thread.title.trim() !== '');
};
